import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import InstitutePage from '@/views/InstitutePage.vue';
import NormalPage from '@/views/NormalPage.vue';
import About from '@/views/About.vue';
import AboutEn from '@/views/AboutEn.vue';
import CampList from '@/views/CampList.vue';
import CampList2 from '@/views/CampList2.vue';
import CampList3 from '@/views/CampList3.vue';
import CampList4 from '@/views/CampList4.vue';
import CampCourses from '@/views/CampCourses.vue';
import Download from '@/views/Download.vue';
import Records from '@/views/Records.vue';
import OnlineCourses from '@/views/OnlineCourses.vue';
import Apply from '@/views/Apply.vue';
import ApplyLogin from '@/views/ApplyLogin.vue';
// import NotFound from '@/views/NotFound.vue';
import store from '@/store';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  }, {
    path: '/*',
    name: 'Page',
    component: NormalPage,
    children: [
      {
        path: '/about/:groupId',
        name: 'About',
        component: About,
      }, {
        path: '/about/',
        redirect: '/about/group1',
      }, {
        path: '/institutes/',
        name: 'InstitutePage',
        component: InstitutePage,
      }, {
        path: '/camp-lists/phase1/:groupId',
        name: 'CampList',
        component: CampList,
      }, {
        path: '/camp-lists/phase1/',
        redirect: '/camp-lists/phase1/group1',
      }, {
        path: '/camp-lists/phase2/:groupId',
        name: 'CampList2',
        component: CampList2,
      }, {
        path: '/camp-lists/phase2/',
        redirect: '/camp-lists/phase2/group1',
      }, {
        path: '/camp-lists/phase3/:groupId',
        name: 'CampList3',
        component: CampList3,
      }, {
        path: '/camp-lists/phase3/',
        redirect: '/camp-lists/phase3/group1',
      }, {
        path: '/camp-lists/phase4/:groupId',
        name: 'CampList4',
        component: CampList4,
      }, {
        path: '/camp-lists/phase4/',
        redirect: '/camp-lists/phase4/group1',
      }, {
        path: '/camp-lists/:groupId',
        redirect: '/camp-lists/phase1/',
      }, {
        path: '/camp-courses/:groupId',
        name: 'CampCourses',
        component: CampCourses,
      }, {
        path: '/camp-courses',
        redirect: '/camp-courses/group1',
      }, {
        path: '/download/:groupId',
        name: 'Download',
        component: Download,
      }, {
        path: '/download/',
        redirect: '/download/group1',
      }, {
        path: '/records',
        name: 'Records',
        component: Records,
      },
      {
        path: '/online-courses',
        name: 'OnlineCourses',
        component: OnlineCourses,
      },
      {
        path: '/new-apply',
        name: 'NewApply',
        component: Apply,
      },
      {
        path: '/apply',
        name: 'Apply',
        component: Apply,
      },
      {
        path: '/apply-login',
        name: 'ApplyLogin',
        component: ApplyLogin,
      }, {
        path: '/en/:groupId',
        name: 'AboutEn',
        component: AboutEn,
      }, {
        path: '/en/',
        redirect: '/en/group1',
      },
    ],
  }, {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    redirect: '/',
    // component: NotFound,
  },

  // {
  //   path: '/about',
  //   name: 'About',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  // },
];
const base = process.env.NODE_ENV === 'production'
  ? '/2021MOE/'
  : '/';
const router = createRouter({
  history: createWebHistory(base),
  base,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0, behavior: 'auto' };
  },
});

router.beforeEach((to, from) => {
  if (from.name === 'Home' && to.name !== 'Home') store.commit('setLoadingState', { status: true });

  // if (to.hash.search('#') === -1) {
  //   window.scrollTo(0, 0);
  // }
  if (to.hash.search('#') === -1) {
    window.scrollTo({
      top: 0,
      behavior: 'instant',
    });
  }
});

router.afterEach((to) => {
  if (to.name !== 'Home') {
    setTimeout(() => {
      store.commit('setLoadingState', { status: false });
    }, 1000);
  }
  // if (to.hash.search('#') === -1) {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'instant',
  //   });
  // }
});

export default router;
